module.exports = __webpack_public_path__ + "img/72000.8fe62560.jpg";